<template>
  <div id="app">
    <router-view
      :disabledDays="disabledDays"
      :highlightedDays="highlightedDays"
      :dayTrips="dayTrips"
      :loadingData="loadingData"
      :calendarLoaded="calendarLoaded"

      @load-month-days="loadMonthDays"
      @load-day-trips="loadDayTrips"
      @set-calendar-loaded="setCalendarLoaded"
      @update-selected-month="updateSelectedMonth"
    />
  </div>
</template>

<script>
export default {
  name: 'OnlineBooking',
  data() {
    return {
      loadingData: false,
      disabledDays: {
        dates: []
      },
      highlightedDays: {
        dates: []
      },
      dayTrips: null,
      calendarLoaded: false
    }
  },
  methods: {
    loadMonthDays(start, end) {
      this.axios.get('/api/load-month-days', { params: { start, end } })
        .then((response) => {
          for (let i = 0; i < response.data.disabledDays.length; i++) {
            const dateParts = response.data.disabledDays[i].split('-')
            const date = new Date(dateParts[0], (parseInt(dateParts[1]) - 1), dateParts[2], 0, 0, 0, 0)
            this.disabledDays.dates.push(date)
          }
          for (let i = 0; i < response.data.highlightedDays.length; i++) {
            const dateParts = response.data.highlightedDays[i].split('-')
            const date = new Date(dateParts[0], (parseInt(dateParts[1]) - 1), dateParts[2], 0, 0, 0, 0)
            this.highlightedDays.dates.push(date)
          }
        }, this)

      this.dayTrips = null
    },
    loadDayTrips(date) {
      this.loadingData = true

      this.axios.get('/api/load-day-trips', { params: { date } })
        .then((response) => {
          this.dayTrips = response.data
          this.loadingData = false
        }, this)
    },
    setCalendarLoaded(value) {
      this.calendarLoaded = value
    },
    updateSelectedMonth(date) {
      localStorage.setItem('selectedMonth', date)
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/App.vue